var listingBase = {
    data: function () {
      return {
        smartFilterParams:[],
        searchIds:[],
        loading: false,
        nextPage: false,
        search:"",
        searchIds:[],
        arResult:{"ITEMS":[]},
        category:0,
        mode:"filterShops",
      }
    },


    created: function() {

        this.arResult = this.allParams.arResult;
        this.isSearch = this.allParams.isSearch;
        this.countLine = this.allParams.countLine;  
        
        
        //
    },

    mounted: function(){
        console.log(this);

    },

    methods: {
        goPage(num){

            this.nextPage = true;
            this.arResult.NAV.CURRENT_PAGE = num;
            this.refreshData();
        },
    
        onScroll(event){
        // console.log(window.scrollY);
        // console.log(window.scrollX);
    
    
        // if(($(window).scrollTop() + $(window).height()) > ($('#shops_vue_<?=$arParams["IBLOCK_ID"] ?>').offset().top + $('#shops_vue_<?=$arParams["IBLOCK_ID"] ?>').height() + 100) && 
        //         this.arResult["NAV"].CURRENT_PAGE !== this.arResult["NAV"].ALL &&
        //         !this.loading) {
            
        //     this.loading = true;
        //     this.addPage();
        // }
    
    
    
        },
    
        smartFilterUse: function(){
    
    
    
        },
    
        outControlImage: function(index, photo, item)
        {
        //console.log("отвули");
    
    
        // this.$set(photo, 'active', false);
        },
    
        addProductHandler: function(item)
        {
            this.addProduct = item;
    
            $.fancybox.open({
                src  : '#card_block',
                type : 'inline',
                opts : {
                    afterShow : function( instance, current ) {
                        console.info( 'done!' );
                    }
                }
            });
            //console.log(item);
        
        },
    
        prepareImages: function(items){
    
            if(!items)
            {
                items = this.arResult["ITEMS"];
            
            }
    
    
            let vue = this;
    
            items.forEach(function(param, i, arr){
    
                
                if(param.GALLERY !== null)
                {
                    
                    if(!param.GALLERY[0].hasOwnProperty('src'))
                    {
                        param.GALLERY[0].src = vue.componentPath+"/images/shop.png";
                        param.GALLERY[0].width = 200;
                        param.GALLERY[0].height = 200;
                    }
    
                    // param.GALLERY.push({src: vue.componentPath+"/images/shop.png", 
                    //                     width: 200,
                    //                     height: 200
                    //                 });
                }
    
                if(param.GALLERY)
                {
                    let width = 100 / param.GALLERY.length;
                    param.GALLERY.forEach(element => {
                        
                        element.width_control = width - 0.5;
    
                        //element.active = false;
                    });
    
                    param.GALLERY[0].active = true;
                }
    
                if(param.PREVIEW_PICTURE == null)
                {
                    param.PREVIEW_PICTURE = {};
                    param.PREVIEW_PICTURE.SRC = vue.componentPath+"/images/shop.png";
                }
            });
    
            return items;
    
        },
    
        getOrder: function()
        {
            let code = false;
    
            if(this.arResult.ORDER)
            {
                this.arResult.ORDER.forEach(function(element, key){
    
                    if(element.SELECTED)
                    {
    
                    code = element["CODE"];
                    }
                });
            }
    
    
            return code;
        },
    
        setOrder: function(event)
        {   
            this.arResult.ORDER.forEach(function(element, key){
    
                if(key == event.target.value)
                {
                    element.SELECTED = true;
                }
                else
                {
                    element.SELECTED = false;
                }
            });
    
    
            this.searchInput();
        },
    
        searchInput: function(query)
        {
        //event.preventDefault();
        //event.stopImmediatePropagation();
            this.refreshData(query);
        },
    
        addPage: function()
        {
            let vue = this;
    
            event.preventDefault();
            event.stopImmediatePropagation();
    
            this.nextPage = true;
            this.arResult.NAV.CURRENT_PAGE = this.arResult.NAV.CURRENT_PAGE+1;
            this.refreshData();
    
        },
    
    
        refreshData: function(dataCustom = false){
    
            let vue = this;
            let data = {};
    
            if(dataCustom)
            {
                data = dataCustom;
            }
            else
            {
                data = {search: this.search, 
                        order: this.getOrder(),  
                        category: this.category, 
                        smartFilter:{},
                        //ids:this.searchIds
                        }; // ключи объекта data соответствуют параметрам метода
            }
           
    
    
    
            if(this.smartFilterParams)
            {
                for(param in this.smartFilterParams)
                {
                    data.smartFilter[param] = this.smartFilterParams[param];
                }
    
            }
    
            let params =  { // Вызывается без постфикса Action
                mode: 'class',
                //navigation: {page: this.arResult.NAV.CURRENT_PAGE},
                data: data,
                signedParameters: this.signedParameters
            };
    
            let number_page = "1";
    
            if(vue.nextPage)
                    {
                        // $('html, body').animate({
                        //         scrollTop: $("#shops_vue_<?=$arParams["IBLOCK_ID"] ?>").offset().top - 200
                        //     }, 500);
                    }
                    
            if(vue.nextPage || vue.firstLoad)
            {
                params.navigation = {page: this.arResult.NAV.CURRENT_PAGE};
                number_page = this.arResult.NAV.CURRENT_PAGE;
                vue.firstLoad = false;
                
            }
    
            vue.loading = true;
    
            let params_query = new URLSearchParams({
                    mode: "class",
                    nav: "page-"+number_page,
                    c: "vue:shops",
                    action: this.mode
            });
    
            data.signedParameters = this.allParams.signedParameters;
            vue.arResult.ITEMS = [];
    
            $.ajax({
                type: "POST",
                url: "/bitrix/services/main/ajax.php?"+params_query.toString(),
                data: data,
                headers: {'x-bitrix-csrf-token': this.allParams.token,
                        'x-bitrix-site-id':  this.allParams.site_id },
                //dataType: "dataType",
                success: function (response) {
    
                    if (response.status === 'success') {
    
                        if(vue.nextPage)
                        {
                            response.data.data = vue.prepareImages(response.data.data);
    
                            vue.$set(vue.arResult, 'ITEMS', response.data.data);
    
                            // response.data.data.forEach(element => {
    
                            //     vue.arResult.ITEMS.push(element);
                            // });
                            
                            vue.nextPage = false;
                        }
                        else
                        {
                            //vue.arResult.ITEMS = [];
                            vue.$set(vue.arResult, 'ITEMS', vue.prepareImages(response.data.data));
                            //vue.arResult.ITEMS = ;
    
                            if(response.data.sections)
                            {
                                vue.sections = response.data.sections;
                                //vue.activeCategoryId = vue.sections[0].ID;
                                
    
                                vue.$nextTick(() => {
                                    vue.getProductsCountByCategory();
                                    vue.runFilterProducts();
                                });
                                
                            }
                        }
    
                        
                        vue.arResult["NAV"] = response.data.nav;
                        vue.arResult.PAGINATION = response.data.pagination;
    
                        vue.loading = false;
    
                    }
                    //console.log(response);
                }
            });
    
        },
      }
  }

if(!window.mixins)
{
    window.mixins = {};
}

//window.mixins.catalog = catalog;
export default listingBase;